import { render, staticRenderFns } from "./orderIndex.vue?vue&type=template&id=ca6ef69a&scoped=true&"
import script from "./orderIndex.vue?vue&type=script&lang=js&"
export * from "./orderIndex.vue?vue&type=script&lang=js&"
import style0 from "./orderIndex.vue?vue&type=style&index=0&id=ca6ef69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6ef69a",
  null
  
)

export default component.exports